// Added by Sejune Oh on 2019-03-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { useState, forwardRef, useImperativeHandle } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Componenet
import Select, { SelectBaseFCProps } from './Select'
import { DEFAULT_INPUT_VARIANT } from '@/styles/Theme'
import { ReactSelectEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface SelectCProps extends SelectBaseFCProps {
  value?: string | number
  description?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SelectContainer = forwardRef(
  (
    {
      value: propsValue,
      id,
      keyProps,
      label,
      menuItems,
      isFullWidth,
      isRequired,
      itemFormatter,
      isEmptyOptionValid,
      isBoolean,
      disabled,
      hidden,
      isFitContent,
      variant,
      description,
      inline,
      inputProps,
      onChange,
    }: SelectCProps,
    ref
  ) => {
    const [innerValue, setInnerValue] = useState<string | number | undefined>(propsValue)

    useImperativeHandle(ref, () => ({ setValue, value: innerValue, menuItems }), [ref, innerValue, menuItems])

    const setValue = (value: any) => setInnerValue(value)

    const handleChange: ReactSelectEvent = (event, child) => {
      if (onChange) {
        onChange(event, child)
      }

      setValue(event.target.value)
    }

    return (
      <Select
        id={id}
        keyProps={keyProps || 'id'}
        onChange={handleChange}
        value={innerValue}
        label={label}
        menuItems={menuItems}
        isFullWidth={isFullWidth}
        isRequired={isRequired}
        itemFormatter={itemFormatter}
        isEmptyOptionValid={isEmptyOptionValid}
        isBoolean={isBoolean}
        disabled={disabled}
        hidden={hidden}
        isFitContent={isFitContent}
        variant={variant || DEFAULT_INPUT_VARIANT}
        description={description}
        inline={inline}
        inputProps={inputProps}
      />
    )
  }
)

export default SelectContainer
